import { createSelector } from '@ngrx/store';
import { getIngredientByPLU } from '@shared/state';
import { getWizzardSimpleItem } from '../getWizzardSimpleItem';
import { isWizzardIngredientSelected } from '../isWizzardIngredientSelected';

export const getWizzardSelectedModifierForIngredient = (ingredientPLU: number) =>
    createSelector(
        getWizzardSimpleItem,
        getIngredientByPLU(ingredientPLU),
        isWizzardIngredientSelected(ingredientPLU),
        (simpleItem, ingredientModel, isIngredientSelected): Nullable<OLO.State.Wizzard.IngredientModifiedModelExtended & OLO.Components.DropDown.DropDownOption> => {
            if (!simpleItem || !ingredientModel || !isIngredientSelected) {
                return null;
            }

            if ('IngredientMode' in ingredientModel && ingredientModel.IngredientMode === OLO.Enums.INGREDIENT_MODE.OPTIONAL) {
                const ingredientAddedToSimpleItem = simpleItem.IngredientsChanges?.IngredientsAdded?.find((ingredient) => ingredient.IngredientPLU === ingredientPLU);
                const addedIngredientModifierID = ingredientAddedToSimpleItem?.ModifierID;
                const mod = ingredientModel.Modifiers?.find((modifier) => modifier.ModifierID === addedIngredientModifierID);

                if (!mod) return null;

                return {
                    ...mod,
                    Id: mod.ModifierID,
                    Name: mod.ModifierName,
                };
            }

            if ('IngredientMode' in ingredientModel && ingredientModel.IngredientMode !== OLO.Enums.INGREDIENT_MODE.OPTIONAL) {
                const mod = simpleItem.IngredientsChanges?.IngredientsModified?.find((ingredient) => ingredient.IngredientPLU === ingredientPLU);

                if (!mod) return null;

                return {
                    ...mod,
                    Id: mod.ModifierID,
                    Name: mod.ModifierName,
                };
            }

            const swapAddedToSimpleItem = simpleItem.IngredientsChanges?.IngredientsSwapped?.find((ingredient) => ingredient.NewIngredientPLU === ingredientPLU);
            const addedSwapModifierID = swapAddedToSimpleItem?.ModifierID;
            const mod = ingredientModel.Modifiers?.find((modifier) => modifier.ModifierID === addedSwapModifierID);

            if (!mod) return null;

            return {
                ...mod,
                Id: mod.ModifierID,
                Name: mod.ModifierName,
            };
        },
    );
